import {CDN_IMAGE_URL} from 'configs';

import React from 'react';
import urlJoin from 'url-join';

import styles from './CertifiedOnceAssets.module.scss';

const ASSETS = urlJoin(CDN_IMAGE_URL, 'p/landing/standards-globe.svg');

function CertifiedOnceAssets() {
  return (
    <div className={styles['certified-assets']}>
      <img
        src={ASSETS}
        className={styles['certified-assets--player']}
        alt="Certified Once"
        height="100%"
        width="auto"
        loading="lazy"
      />
    </div>
  );
}

export default CertifiedOnceAssets;
